import React, { useContext, useCallback, useMemo } from 'react';
import {
	IViewModifierGroupContext,
	ViewModifierGroupContext,
} from '../../viewModifierGroupState/viewModifierGroupContext';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { ModalAssignModifierGroupToRestaurants } from 'components/ModalWindows/ModalAssignModifierGroupToRestaurants';
import { ModalEditModifierTemplate } from 'components/ModalWindows/ModalEditModifierTemplate';
import { ModalEditInclusiveForModGroup } from 'components/ModalWindows/ModalEditInclusiveForModGroup';

export const ModalWindows: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		refetchData,
		refetchRestPropsData,
		modifierGroupFullInfo,
		typeOfModalWindow,
		restaurantIdForRestaurantProps,
		restaurantProps,
		accessibleRestaurants,
	} = useContext<IViewModifierGroupContext>(ViewModifierGroupContext);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, [changeTypeOfModalWindow]);

	const handleCloseModalWithRefetchData = useCallback(() => {
		refetchData(true);
		changeTypeOfModalWindow(null);
	}, [refetchData, changeTypeOfModalWindow]);

	const handleCloseInclusiveModalWithRefetchData = useCallback(() => {
		refetchRestPropsData(true);
		changeTypeOfModalWindow(null);
	}, [refetchRestPropsData, changeTypeOfModalWindow]);

	const handleCloseModalWithError = useCallback(() => {
		changeTypeOfModalWindow('errorUpdatingModifierGroup');
	}, [changeTypeOfModalWindow]);

	const handleCloseModGroupHasPortionsError = useCallback(() => {
		changeTypeOfModalWindow('errorModGroupHasPortions');
	}, [changeTypeOfModalWindow]);

	const selectedRestaurant = useMemo(() => {
		return accessibleRestaurants.find((r) => r.id === restaurantIdForRestaurantProps) || null;
	}, [accessibleRestaurants, restaurantIdForRestaurantProps]);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			{typeOfModalWindow === 'errorUpdatingModifierGroup' && (
				<ModalSentError
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="errorUpdatingModifierGroup"
				/>
			)}
			{typeOfModalWindow === 'errorModGroupHasPortions' && (
				<ModalSentError
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="errorModGroupHasPortions"
				/>
			)}
			{typeOfModalWindow === 'assignRestaurants' && (
				<ModalAssignModifierGroupToRestaurants
					onCloseModal={handleCloseModalWithRefetchData}
					onFailureEvent={handleCloseModal}
					onShowError={handleCloseModalWithError}
					modifierGroupId={modifierGroupFullInfo?.id || ''}
				/>
			)}
			{typeOfModalWindow === 'editModifiersTemplate' && (
				<ModalEditModifierTemplate
					onCloseModal={handleCloseModalWithRefetchData}
					onFailureEvent={handleCloseModal}
					onShowError={handleCloseModalWithError}
					onShowProductHasPortionsError={handleCloseModGroupHasPortionsError}
					modifierGroupId={modifierGroupFullInfo?.id || ''}
					customerId={modifierGroupFullInfo?.customer.id || ''}
				/>
			)}
			{typeOfModalWindow === 'editInclusive' && restaurantIdForRestaurantProps && restaurantProps && (
				<ModalEditInclusiveForModGroup
					onCloseModal={handleCloseInclusiveModalWithRefetchData}
					onFailureEvent={handleCloseModal}
					onShowError={handleCloseModalWithError}
					restaurantId={restaurantIdForRestaurantProps}
					modifierGroupId={modifierGroupFullInfo?.id || ''}
					modifierGroupName={modifierGroupFullInfo?.name || ''}
					customerName={restaurantProps.customer.name}
					restaurantName={selectedRestaurant?.name || ''}
					parents={restaurantProps.parents}
				/>
			)}
		</ModalWrapper>
	);
};
